export default {
  head: {
    title: 'OnDemand operations billing',
    action: {
      search: {
        tooltip: 'Search single operation by Operation Id'
      }
    }
  },
  footer: {
    label: 'Total cost',
    tooltip: 'Value from entire period including selected filters'
  },
  dialog: {
    search: {
      title: 'Search OnDemand billing operation'
    },
    details: {
      title: 'OnDemand operation details'
    }
  }
};
